module.exports = __webpack_public_path__ + "img/group-2990.ea82e3fc.jpg";